import React from "react";
import cn from "classnames";
import { Renderer } from "react-dom";
import { LabelHint } from "./LabelHint";

type Props = {
  label?: string;
  labelHint?: string;
  labelAdditionalContent?: Renderer | JSX.Element;
  description?: string;
  required?: boolean;
  className?: {
    label?: string;
    description?: string;
  };
};

export const InputLabel: React.FC<Props> = ({
  label,
  labelHint,
  labelAdditionalContent,
  description,
  required = false,
  className,
}) => {
  return (
    <>
      {label && (
        <>
          <label className={cn(className?.label, "font-bold")}>
            <>
              {label}
              {required && <span className={"text-red-500"}>*</span>}
              <span className={"text-gray-500"}>&nbsp;&nbsp;</span>
              {labelAdditionalContent && (
                <>
                  {labelAdditionalContent}
                  &nbsp;&nbsp;
                </>
              )}
              {labelHint && (
                <LabelHint hint={labelHint} className={"inline-flex text-xs"} />
              )}
            </>
          </label>
          {description && (
            <p className={cn("mb-2", "text-gray-400", className?.description)}>
              {description}
            </p>
          )}
        </>
      )}
    </>
  );
};
